import { PATIENT_THEME } from "../../patientTheme";
import { FORM_FIELD } from "../../../../ui/formTheme";

/** Shared modal action buttons — patient module theme */
export const STAFF_SCHEDULE_MODAL_BTN = {
  cancel: `inline-flex items-center justify-center gap-1.5 h-10 min-w-[5.5rem] px-5 text-sm font-semibold rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed border ${PATIENT_THEME.button.outline}`,
  primary: `inline-flex items-center justify-center gap-1.5 h-10 min-w-[6.5rem] px-5 text-sm font-semibold rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed border shadow-sm ${PATIENT_THEME.button.primary}`,
};

/** Time dropdown inside the grouped time box */
export const TIME_SELECT_CLASS = [
  "h-10 min-w-0 appearance-none rounded-md border border-indigo-200",
  "bg-indigo-50/60 px-3 py-2 text-sm font-semibold text-slate-800 text-center",
  "cursor-pointer transition-colors hover:border-indigo-300 hover:bg-indigo-50",
  PATIENT_THEME.fieldFocus,
  "disabled:opacity-60 disabled:cursor-not-allowed",
].join(" ");

export const TIME_FIELD_LABEL = FORM_FIELD.label.replace("mb-2", "mb-2 text-indigo-900");

export const TIME_NOTES_TEXTAREA = [
  FORM_FIELD.control,
  FORM_FIELD.enabled,
  "resize-none min-h-[5.5rem]",
].join(" ");
